import {
  PAGE,
  // LOGOUT,
  LOAD_DATA,
  MSG_SUCCESS,
  MSG_ADVERTENCIA,
  MSG_ERROR,
  EJECUTAR_ACCION,
  PAGINA,
  LIMPIAR_MENSAJE,
  MSG_INFORMACION,
} from '../actions';

const INIT_STATE = {
  informacionEstado: {},
  loading: false,
  success: false,
  mensaje: '',
  tipoMensaje: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PAGINA:
      return {
        ...state,
        loading: false,
        informacionEstado: {
          ...state.informacionEstado,
          [action.payload.data.clavePagina]: {
            ...state.informacionEstado[action.payload.data.clavePagina],
            ...action.payload.data.values,
          },
        },
      };
    case PAGE:
      if (action.payload.data.load) {
        return {
          ...state,
          loading: false,
          success: false,
          informacionEstado: {
            ...state.informacionEstado,
            [action.payload.data.keyPage]: {
              ...state.informacionEstado[action.payload.data.keyPage],
              datos: action.payload.data.data,
            },
          },
        };
      }
      return {
        ...state,
        loading: false,
        success: false,
        informacionEstado: {
          ...state.informacionEstado,
          [action.payload.data.keyPage]: {
            ...state.informacionEstado[action.payload.data.keyPage],
            ...action.payload.data.values,
          },
        },
      };
    case LOAD_DATA:
      return {
        ...state,
        loading: true,
        success: false,
        mensaje: '',
      };
    case EJECUTAR_ACCION:
      return {
        ...state,
        loading: true,
        success: false,
        mensaje: '',
      };
    case MSG_SUCCESS:
      return {
        ...state,
        loading: false,
        tipoMensaje: 1,
        mensaje: action.payload.mensaje,
      };
    case MSG_ADVERTENCIA:
      return {
        ...state,
        loading: false,
        tipoMensaje: 2,
        mensaje: action.payload.mensaje,
      };
    case MSG_ERROR:
      return {
        ...state,
        loading: false,
        tipoMensaje: 3,
        mensaje: action.payload.mensaje,
      };
    case MSG_INFORMACION:
      return {
        ...state,
        tipoMensaje: 4,
        mensaje: action.payload.mensaje,
      };
    case LIMPIAR_MENSAJE:
      return {
        ...state,
        loading: false,
        mensaje: '',
      };
    /* case LOGOUT:
      return {
        ...state,
        ...INIT_STATE,
      }; */
    default:
      return state;
  }
};
